__turbopack_export_value__({
  "body-logo-18": "Tabs-module-scss-module__G_fRfW__body-logo-18",
  "body-text-12": "Tabs-module-scss-module__G_fRfW__body-text-12",
  "body-text-14": "Tabs-module-scss-module__G_fRfW__body-text-14",
  "body-text-16": "Tabs-module-scss-module__G_fRfW__body-text-16",
  "body-text-18": "Tabs-module-scss-module__G_fRfW__body-text-18",
  "body-text-20": "Tabs-module-scss-module__G_fRfW__body-text-20",
  "body-text-24": "Tabs-module-scss-module__G_fRfW__body-text-24",
  "body-text-24-2": "Tabs-module-scss-module__G_fRfW__body-text-24-2",
  "body-text-heading-2": "Tabs-module-scss-module__G_fRfW__body-text-heading-2",
  "body-text-heading-3": "Tabs-module-scss-module__G_fRfW__body-text-heading-3",
  "body-text-medium-14": "Tabs-module-scss-module__G_fRfW__body-text-medium-14",
  "body-text-medium-16": "Tabs-module-scss-module__G_fRfW__body-text-medium-16",
  "body-text-medium-18": "Tabs-module-scss-module__G_fRfW__body-text-medium-18",
  "body-text-medium2-18": "Tabs-module-scss-module__G_fRfW__body-text-medium2-18",
  "body-text2-14": "Tabs-module-scss-module__G_fRfW__body-text2-14",
  "body-text2-16": "Tabs-module-scss-module__G_fRfW__body-text2-16",
  "button-primary-text": "Tabs-module-scss-module__G_fRfW__button-primary-text",
  "button-text": "Tabs-module-scss-module__G_fRfW__button-text",
  "button2-text": "Tabs-module-scss-module__G_fRfW__button2-text",
  "card-shadow": "Tabs-module-scss-module__G_fRfW__card-shadow",
  "effect-menu": "Tabs-module-scss-module__G_fRfW__effect-menu",
  "header-1": "Tabs-module-scss-module__G_fRfW__header-1",
  "main-container": "Tabs-module-scss-module__G_fRfW__main-container",
  "main-footer-container": "Tabs-module-scss-module__G_fRfW__main-footer-container",
  "main-header-container": "Tabs-module-scss-module__G_fRfW__main-header-container",
  "tabs": "Tabs-module-scss-module__G_fRfW__tabs",
  "tabs__item": "Tabs-module-scss-module__G_fRfW__tabs__item",
  "tabs__item_active": "Tabs-module-scss-module__G_fRfW__tabs__item_active",
  "tabs__list": "Tabs-module-scss-module__G_fRfW__tabs__list",
  "txt-12-bold": "Tabs-module-scss-module__G_fRfW__txt-12-bold",
  "txt-14-bold": "Tabs-module-scss-module__G_fRfW__txt-14-bold",
  "txt-14-bold-caps": "Tabs-module-scss-module__G_fRfW__txt-14-bold-caps",
  "txt-14-med": "Tabs-module-scss-module__G_fRfW__txt-14-med",
  "txt-16-bold": "Tabs-module-scss-module__G_fRfW__txt-16-bold",
  "txt-16-med": "Tabs-module-scss-module__G_fRfW__txt-16-med",
  "txt-18-bold": "Tabs-module-scss-module__G_fRfW__txt-18-bold",
  "txt-18-medium": "Tabs-module-scss-module__G_fRfW__txt-18-medium",
  "txt-18-medium-24": "Tabs-module-scss-module__G_fRfW__txt-18-medium-24",
  "txt-24-semi": "Tabs-module-scss-module__G_fRfW__txt-24-semi",
  "wrapper": "Tabs-module-scss-module__G_fRfW__wrapper",
});
